import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const CardField = ({ label, children }) => (
  <Typography
    variant="body2"
    color="text.secondary"
    sx={{ lineHeight: 1.45, display: "block" }}
  >
    {label ? (
      <Box component="span" sx={{ opacity: 0.72 }}>
        {label}:{" "}
      </Box>
    ) : null}
    <Box component="span" sx={{ color: "text.primary", fontWeight: 500 }}>
      {children}
    </Box>
  </Typography>
);

export const CardPrice = ({ label, price, oldPrice, currency }) => (
  <Typography
    variant="body2"
    color="text.secondary"
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.75,
      flexWrap: "wrap",
      lineHeight: 1.45,
    }}
  >
    <Box component="span" sx={{ opacity: 0.72 }}>
      {label}:
    </Box>
    {oldPrice != null && oldPrice !== "" && (
      <Box
        component="span"
        sx={{ textDecoration: "line-through", color: "error.main" }}
      >
        {oldPrice} {currency}
      </Box>
    )}
    <Box
      component="span"
      sx={{
        color: oldPrice != null && oldPrice !== "" ? "success.main" : "text.primary",
        fontWeight: 600,
      }}
    >
      {price} {currency}
    </Box>
  </Typography>
);

export const CardStatus = ({ outOfStock, visible }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>
      <Chip
        size="small"
        variant="outlined"
        label={outOfStock ? t("filters.outOfStock") : t("filters.inStock")}
        color={outOfStock ? "error" : "success"}
      />
      <Chip
        size="small"
        variant="outlined"
        label={visible ? t("filters.visible") : t("filters.hidden")}
        color={visible ? "success" : "error"}
      />
    </Stack>
  );
};
